module.exports = __webpack_public_path__ + "static/media/checked.06f80019.svg";